import React from 'react';
import s from './styles.module.css'
import Wrapper from "../../components/wrapper";
import HeaderTitle from "../../components/header_title";

const Conditions = () => {
  return (
    <div className={s.about}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Betingelser for at få et lån</h1>

        <p>
          Kravene til at få et lån kan variere fra långiver til långiver. De fleste
          udbydere vurderer ansøgningen ud fra en række grundlæggende kriterier, herunder
          alder, indkomst og økonomisk situation.
        </p>

        <h2>Minimumsalder</h2>
        <p>
          De fleste långivere kræver, at ansøgeren er mindst 18 år gammel. Nogle udbydere
          kan dog have en højere aldersgrænse.
        </p>

        <h2>Fast indkomst</h2>
        <p>
          Mange långivere ønsker dokumentation for en stabil indkomst. Det kan være løn,
          pension eller anden regelmæssig indtægt, som viser, at du har mulighed for at
          tilbagebetale lånet.
        </p>

        <h2>Bopæl i Danmark</h2>
        <p>
          De fleste låneudbydere kræver, at ansøgeren har fast bopæl i Danmark og et gyldigt
          CPR-nummer.
        </p>

        <h2>MitID</h2>
        <p>
          Hos mange långivere foregår identifikation og underskrift digitalt via MitID.
          Det gør ansøgningsprocessen hurtigere og mere sikker.
        </p>

        <h2>Kreditvurdering</h2>
        <p>
          Alle ansøgninger vurderes individuelt. Långiveren ser blandt andet på din økonomi,
          eksisterende gæld og betalingsevne, før der træffes en beslutning.
        </p>

        <h2>Ansøg hos flere udbydere</h2>
        <p>
          Da kravene varierer mellem långivere, kan det være en fordel at sende ansøgninger
          til flere udbydere. Det giver mulighed for at sammenligne forskellige tilbud og
          øger sandsynligheden for at finde et lån, der passer til dine behov.
        </p>

        <h2>Læs altid vilkårene</h2>
        <p>
          Inden du accepterer et lånetilbud, bør du læse alle vilkår og betingelser grundigt.
          Vær opmærksom på lånets løbetid, gebyrer og tilbagebetalingsbetingelser.
        </p>
      </Wrapper>
    </div>
  );
};

export default Conditions;
